import { BarChart3, Workflow, Layers, Shield } from 'lucide-react';
import Card from '@/components/common/ui/Card';

const plans = [
    {
        title: "Advanced Data Analytics",
        description:
            "Leverage powerful analytics to gain actionable insights from your data, driving informed business strategies.",
        icon: BarChart3,
    },
    {
        title: "Automated Workflows",
        description:
            "Increase efficiency by automating routine tasks, allowing your team to focus on strategic initiatives.",
        icon: Workflow,
    },
    {
        title: "Scalable Infrastructure",
        description:
            "Our solutions grow with your business, ensuring seamless scalability and adaptability to changing needs.",
        icon: Layers,
    },
    {
        title: "Enhanced Security",
        description:
            "Protect your data with robust security, ensuring compliance and safeguarding sensitive information.",
        icon: Shield,
    }
];

export default function OtherServices() {
    return (
        <section className="container pb-24 pt-6">
            <div className="text-center">
                <h3 className="text-xl md:text-3xl font-bold text-white leading-tight mb-12">
                    Empowering businesses through seamless technology and exceptional service, one conversation at a time.
                </h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
                {plans.map((plan, index) => (
                    <Card
                        key={index}
                        title={plan.title}
                        description={plan.description}
                        icon={plan.icon}
                    />
                ))}
            </div>
        </section>
    );
}